import React from 'react';
import PropTypes from 'prop-types';

// Components
import StatusChip, { connectionChip } from './StatusChip';

// Constants
import { isNotNull } from '../constants';
import { T, FONT_MONO } from '../constants/tokens';

/**
 * Badge connection, power and firmware.
 *
 * v7 collapses what used to be a column of 40px icons into two mono lines, so
 * the widget sits inside a list row instead of setting the row's height.
 */
export default function BadgeStatusWidget({ style = {}, badge, showLabel = false }) {
  if (badge == null) return null;

  const connection = connectionChip(badge);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: 2, ...style }}>
      {showLabel &&
        <span
          style={{
            fontFamily: FONT_MONO,
            fontSize: 12,
            fontWeight: 500,
            textTransform: 'uppercase',
            color: T.muted
          }}
        >
          Badge status
        </span>}

      {connection && <StatusChip tone={connection.tone} label={connection.label} />}

      {isNotNull(badge.getFirmwareVersion()) &&
        <span style={{ fontFamily: FONT_MONO, fontSize: 12, color: T.mutedSoft }}>
          v{badge.getFirmwareVersion()}
        </span>}
    </div>
  );
}

BadgeStatusWidget.propTypes = {
  style: PropTypes.object,
  badge: PropTypes.object,
  showLabel: PropTypes.bool
};
